<template>
  <label
    v-if="!!$slots.default()[0].children"
    :class="cssCls"
    v-html="escapeLabel"
  />
</template>

<script>
import { encode} from 'html-entities'

export default {
  name: 'MsLabel',

  props: {
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    cssCls () {
      return {
        'ms-label': true,
        required: this.required
      }
    },

    escapeLabel () {
      const textSlot = this.$slots.default()

      return encode(textSlot && textSlot.length > 0 ? textSlot[0].children : '')
    }
  }
}
</script>

<style lang="scss" scoped>
  .ms-label {
    display: inline-block;
    @include label();
    margin-bottom: 2px;
    color: #4e5b6a;

    &.required {
      &::after {
        content: ' *';
        color: red;
      }
    }
  }
</style>
